export const limitTo = (limiter: number, number: number): number | string => {
  return number > limiter ? `${limiter}+` : number;
};
